/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ProductDatasheetPreviewByRefResp } from '../models/product-datasheet-preview-by-ref-resp';
import { ProductDatasheetPreviewByUuidResp } from '../models/product-datasheet-preview-by-uuid-resp';
import { ProductDeleteResp } from '../models/product-delete-resp';
import { ProductDetailedDto } from '../models/product-detailed-dto';
import { ProductGetAllReq } from '../models/product-get-all-req';
import { ProductGetAllResp } from '../models/product-get-all-resp';
import { ProductGetByReferenceResp } from '../models/product-get-by-reference-resp';
import { ProductHistoryResp } from '../models/product-history-resp';
import { ProductImageMergedByRefResp } from '../models/product-image-merged-by-ref-resp';
import { ProductImageMergedByUuidResp } from '../models/product-image-merged-by-uuid-resp';
import { ProductPutRangeReq } from '../models/product-put-range-req';
import { DataToIso88591Req } from '../models/data-to-iso-88591-req';

@Injectable({
  providedIn: 'root',
})
export class ProductService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation productPut
   */
  static readonly ProductPutPath = '/product';

  /**
   * Crear o actualizar producto
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productPut$Response(params: {
    body: ProductDetailedDto
  }): Observable<StrictHttpResponse<{
'success'?: boolean;
}>> {

    const rb = new RequestBuilder(this.rootUrl, ProductService.ProductPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'success'?: boolean;
        }>;
      })
    );
  }

  /**
   * Crear o actualizar producto
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `productPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productPut(params: {
    body: ProductDetailedDto
  }): Observable<{
'success'?: boolean;
}> {

    return this.productPut$Response(params).pipe(
      map((r: StrictHttpResponse<{
'success'?: boolean;
}>) => r.body as {
'success'?: boolean;
})
    );
  }

  /**
   * Path part for operation productGetAll
   */
  static readonly ProductGetAllPath = '/product';

  /**
   * Get all products
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productGetAll()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productGetAll$Response(params: {

    /**
     * pagination load page
     */
    page?: number;
    body: ProductGetAllReq
  }): Observable<StrictHttpResponse<ProductGetAllResp>> {

    const rb = new RequestBuilder(this.rootUrl, ProductService.ProductGetAllPath, 'post');
    if (params) {
      rb.query('page', params.page, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductGetAllResp>;
      })
    );
  }

  /**
   * Get all products
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `productGetAll$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productGetAll(params: {

    /**
     * pagination load page
     */
    page?: number;
    body: ProductGetAllReq
  }): Observable<ProductGetAllResp> {

    return this.productGetAll$Response(params).pipe(
      map((r: StrictHttpResponse<ProductGetAllResp>) => r.body as ProductGetAllResp)
    );
  }

  /**
   * Path part for operation productGet
   */
  static readonly ProductGetPath = '/product/{uuid}';

  /**
   * Get information about a product
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  productGet$Response(params: {

    /**
     * product uuid
     */
    uuid: string;
  }): Observable<StrictHttpResponse<ProductDetailedDto>> {

    const rb = new RequestBuilder(this.rootUrl, ProductService.ProductGetPath, 'get');
    if (params) {
      rb.path('uuid', params.uuid, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductDetailedDto>;
      })
    );
  }

  /**
   * Get information about a product
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `productGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productGet(params: {

    /**
     * product uuid
     */
    uuid: string;
  }): Observable<ProductDetailedDto> {

    return this.productGet$Response(params).pipe(
      map((r: StrictHttpResponse<ProductDetailedDto>) => r.body as ProductDetailedDto)
    );
  }

  /**
   * Path part for operation productDelete
   */
  static readonly ProductDeletePath = '/product/{uuid}';

  /**
   * Delete a product
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  productDelete$Response(params: {

    /**
     * product uuid
     */
    uuid: string;
  }): Observable<StrictHttpResponse<ProductDeleteResp>> {

    const rb = new RequestBuilder(this.rootUrl, ProductService.ProductDeletePath, 'delete');
    if (params) {
      rb.path('uuid', params.uuid, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductDeleteResp>;
      })
    );
  }

  /**
   * Delete a product
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `productDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productDelete(params: {

    /**
     * product uuid
     */
    uuid: string;
  }): Observable<ProductDeleteResp> {

    return this.productDelete$Response(params).pipe(
      map((r: StrictHttpResponse<ProductDeleteResp>) => r.body as ProductDeleteResp)
    );
  }

  /**
   * Path part for operation productGetByReference
   */
  static readonly ProductGetByReferencePath = '/product/reference/{reference}';

  /**
   * Get product by reference
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productGetByReference()` instead.
   *
   * This method doesn't expect any request body.
   */
  productGetByReference$Response(params: {

    /**
     * With detail
     */
    with_details?: boolean;

    /**
     * reference
     */
    reference: string;
  }): Observable<StrictHttpResponse<ProductGetByReferenceResp>> {

    const rb = new RequestBuilder(this.rootUrl, ProductService.ProductGetByReferencePath, 'get');
    if (params) {
      rb.query('with_details', params.with_details, {});
      rb.path('reference', params.reference, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductGetByReferenceResp>;
      })
    );
  }

  /**
   * Get product by reference
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `productGetByReference$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productGetByReference(params: {

    /**
     * With detail
     */
    with_details?: boolean;

    /**
     * reference
     */
    reference: string;
  }): Observable<ProductGetByReferenceResp> {

    return this.productGetByReference$Response(params).pipe(
      map((r: StrictHttpResponse<ProductGetByReferenceResp>) => r.body as ProductGetByReferenceResp)
    );
  }

  /**
   * Path part for operation productPutRange
   */
  static readonly ProductPutRangePath = '/product/product-range';

  /**
   * Crear gama de producto
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productPutRange()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productPutRange$Response(params: {
    body: ProductPutRangeReq
  }): Observable<StrictHttpResponse<{
'success'?: boolean;
}>> {

    const rb = new RequestBuilder(this.rootUrl, ProductService.ProductPutRangePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'success'?: boolean;
        }>;
      })
    );
  }

  /**
   * Crear gama de producto
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `productPutRange$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productPutRange(params: {
    body: ProductPutRangeReq
  }): Observable<{
'success'?: boolean;
}> {

    return this.productPutRange$Response(params).pipe(
      map((r: StrictHttpResponse<{
'success'?: boolean;
}>) => r.body as {
'success'?: boolean;
})
    );
  }

  /**
   * Path part for operation productHistory
   */
  static readonly ProductHistoryPath = '/product/history/{uuid}';

  /**
   * Get history about a product
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productHistory()` instead.
   *
   * This method doesn't expect any request body.
   */
  productHistory$Response(params: {

    /**
     * product uuid
     */
    uuid: string;
  }): Observable<StrictHttpResponse<ProductHistoryResp>> {

    const rb = new RequestBuilder(this.rootUrl, ProductService.ProductHistoryPath, 'get');
    if (params) {
      rb.path('uuid', params.uuid, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductHistoryResp>;
      })
    );
  }

  /**
   * Get history about a product
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `productHistory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productHistory(params: {

    /**
     * product uuid
     */
    uuid: string;
  }): Observable<ProductHistoryResp> {

    return this.productHistory$Response(params).pipe(
      map((r: StrictHttpResponse<ProductHistoryResp>) => r.body as ProductHistoryResp)
    );
  }

  /**
   * Path part for operation productImageMergedByUuid
   */
  static readonly ProductImageMergedByUuidPath = '/product/{uuid}/imagemerged';

  /**
   * Get product by reference
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productImageMergedByUuid()` instead.
   *
   * This method doesn't expect any request body.
   */
  productImageMergedByUuid$Response(params: {

    /**
     * Size
     */
    doublesize?: boolean;

    /**
     * uuid
     */
    uuid: string;
  }): Observable<StrictHttpResponse<ProductImageMergedByUuidResp>> {

    const rb = new RequestBuilder(this.rootUrl, ProductService.ProductImageMergedByUuidPath, 'get');
    if (params) {
      rb.query('doublesize', params.doublesize, {});
      rb.path('uuid', params.uuid, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductImageMergedByUuidResp>;
      })
    );
  }

  /**
   * Get product by reference
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `productImageMergedByUuid$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productImageMergedByUuid(params: {

    /**
     * Size
     */
    doublesize?: boolean;

    /**
     * uuid
     */
    uuid: string;
  }): Observable<ProductImageMergedByUuidResp> {

    return this.productImageMergedByUuid$Response(params).pipe(
      map((r: StrictHttpResponse<ProductImageMergedByUuidResp>) => r.body as ProductImageMergedByUuidResp)
    );
  }

  /**
   * Path part for operation productImageMergedByRef
   */
  static readonly ProductImageMergedByRefPath = '/product/ref/{ref}/imagemerged';

  /**
   * Get product by reference
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productImageMergedByRef()` instead.
   *
   * This method doesn't expect any request body.
   */
  productImageMergedByRef$Response(params: {

    /**
     * Size
     */
    doublesize?: boolean;

    /**
     * reference
     */
    ref: string;
  }): Observable<StrictHttpResponse<ProductImageMergedByRefResp>> {

    const rb = new RequestBuilder(this.rootUrl, ProductService.ProductImageMergedByRefPath, 'get');
    if (params) {
      rb.query('doublesize', params.doublesize, {});
      rb.path('ref', params.ref, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductImageMergedByRefResp>;
      })
    );
  }

  /**
   * Get product by reference
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `productImageMergedByRef$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productImageMergedByRef(params: {

    /**
     * Size
     */
    doublesize?: boolean;

    /**
     * reference
     */
    ref: string;
  }): Observable<ProductImageMergedByRefResp> {

    return this.productImageMergedByRef$Response(params).pipe(
      map((r: StrictHttpResponse<ProductImageMergedByRefResp>) => r.body as ProductImageMergedByRefResp)
    );
  }

  /**
   * Path part for operation dataToIso88591
   */
  static readonly DataToIso88591Path = '/product/to-raw-iso88591-string';

  /**
   * Data to ISO
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dataToIso88591()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dataToIso88591$Response(params: {
    body: DataToIso88591Req
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, ProductService.DataToIso88591Path, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * Data to ISO
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `dataToIso88591$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dataToIso88591(params: {
    body: DataToIso88591Req
  }): Observable<string> {

    return this.dataToIso88591$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation productDatasheetPreviewByRef
   */
  static readonly ProductDatasheetPreviewByRefPath = '/product/ref/{reference}/datasheetpreview';

  /**
   * Get datasheet preview product by reference
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productDatasheetPreviewByRef()` instead.
   *
   * This method doesn't expect any request body.
   */
  productDatasheetPreviewByRef$Response(params: {

    /**
     * Reference
     */
    reference: string;
  }): Observable<StrictHttpResponse<ProductDatasheetPreviewByRefResp>> {

    const rb = new RequestBuilder(this.rootUrl, ProductService.ProductDatasheetPreviewByRefPath, 'get');
    if (params) {
      rb.path('reference', params.reference, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductDatasheetPreviewByRefResp>;
      })
    );
  }

  /**
   * Get datasheet preview product by reference
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `productDatasheetPreviewByRef$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productDatasheetPreviewByRef(params: {

    /**
     * Reference
     */
    reference: string;
  }): Observable<ProductDatasheetPreviewByRefResp> {

    return this.productDatasheetPreviewByRef$Response(params).pipe(
      map((r: StrictHttpResponse<ProductDatasheetPreviewByRefResp>) => r.body as ProductDatasheetPreviewByRefResp)
    );
  }

  /**
   * Path part for operation productDatasheetPreviewByUuid
   */
  static readonly ProductDatasheetPreviewByUuidPath = '/product/uuid/{uuid}/datasheetpreview';

  /**
   * Get datasheet preview product by uuid
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productDatasheetPreviewByUuid()` instead.
   *
   * This method doesn't expect any request body.
   */
  productDatasheetPreviewByUuid$Response(params: {

    /**
     * Product uuid
     */
    uuid: string;
  }): Observable<StrictHttpResponse<ProductDatasheetPreviewByUuidResp>> {

    const rb = new RequestBuilder(this.rootUrl, ProductService.ProductDatasheetPreviewByUuidPath, 'get');
    if (params) {
      rb.path('uuid', params.uuid, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductDatasheetPreviewByUuidResp>;
      })
    );
  }

  /**
   * Get datasheet preview product by uuid
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `productDatasheetPreviewByUuid$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productDatasheetPreviewByUuid(params: {

    /**
     * Product uuid
     */
    uuid: string;
  }): Observable<ProductDatasheetPreviewByUuidResp> {

    return this.productDatasheetPreviewByUuid$Response(params).pipe(
      map((r: StrictHttpResponse<ProductDatasheetPreviewByUuidResp>) => r.body as ProductDatasheetPreviewByUuidResp)
    );
  }

}
